/** Initials for graph center nodes; falls back to "You" when name is empty. */
export function getCenterNodeInitials(name, fallback = "You") {
  const trimmed = String(name || "").trim();
  if (!trimmed) return fallback;
  // Keep the personal ego label as "You" (not initials "YO").
  if (trimmed.toLowerCase() === "you") return "You";

  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return fallback;
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export function getCenterUserEmail(stakeholder) {
  return stakeholder?.raw?.email || stakeholder?.raw?.user_email || "";
}
